/**
 * Settings Button Component
 * Opens the settings modal
 */

import { type FC, memo } from 'react';
import styles from './Actions.module.css';
import Image from '../../../../../shared/components/Image';
import { useAppStore } from 'store/app/appStore';
import { trackClick } from 'core/utils/clickTracking';
import { testIds } from 'core/testIds';

export const SettingsButton: FC = memo(() => {
    const showSettingsModal = useAppStore((state) => state.showSettingsModal);
    const setShowSettingsModal = useAppStore((state) => state.setShowSettingsModal);
    const isSearchActive = useAppStore((state) => state.isSearchActive);

    const handleClick = trackClick('settings_button', () => {
        if (isSearchActive) return; // Prevent opening settings if search is active
        setShowSettingsModal(!showSettingsModal);
    });

    return (
        <button
            className={`${styles.settingsButtonContainer} ${isSearchActive ? styles.disabled : ''}`}
            onClick={handleClick}
            aria-label={showSettingsModal ? 'Close settings' : 'Open settings'}
            aria-pressed={showSettingsModal}
            disabled={isSearchActive}
            aria-disabled={isSearchActive}
            data-testid={testIds.statusBar.settingsButton}
        >
            <Image 
                src={showSettingsModal ? '/ui/menuClose' : '/ui/menu'} 
                manualAffix=".svg" 
                className={isSearchActive ? styles.disabledIcon : ''}
            />
        </button>
    );
});

SettingsButton.displayName = 'SettingsButton';
